import InstitutionFuturesReportingOnboardingForm from '@/features/institution/futures/reporting/components/onboarding-form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingReportingPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="reporting" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionFuturesReportingOnboardingForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingReportingPage.displayName = 'InstitutionOnboardingReportingPage';

export default InstitutionOnboardingReportingPage;
